import type { GetInternalNotesResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { requestInternalNotesKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetRequestInternalNotes(
  requestId: number,
): UseQueryResult<GetInternalNotesResponse> {
  return useQuery<GetInternalNotesResponse>({
    queryFn: () =>
      apiClient
        .url(`/requests/${requestId}/internal-notes`)
        .get()
        .json<GetInternalNotesResponse>(),
    queryKey: requestInternalNotesKeys.byRequestId(requestId),
    staleTime: 30 * 1000,
  });
}
